import { TableColumnsType } from 'antd';
import { DataTypeReportTPP } from 'store/ducks/Reportings/types';

export const columns: TableColumnsType<DataTypeReportTPP> = [
  {
    title: 'Name of the financial entity',
    width: 150,
    dataIndex: 'entity_name',
    key: 'entity_name',
    fixed: 'left',
  },
  {
    title: 'Alternative providers identified',
    width: 150,
    dataIndex: 'alternative_providers_identified',
    key: 'alternative_providers_identified',
  },
  {
    title: 'Alternatives exit',
    width: 150,
    dataIndex: 'alternatives_exit',
    key: 'alternatives_exit',
    render: (value: boolean) => (value ? value : ''),
  },
  {
    title: 'Description',
    width: 150,
    dataIndex: 'description',
    key: 'description',
  },
  {
    title: 'Dora criticality',
    width: 150,
    dataIndex: 'dora_criticality',
    key: 'dora_criticality',
  },
  {
    title: 'TPP Valid from',
    width: 150,
    dataIndex: 'start_date',
    key: 'start_date',
  },
  {
    title: 'TPP Valid to',
    width: 150,
    dataIndex: 'end_date',
    key: 'end_date',
  },
  {
    title: 'Last audit date',
    width: 150,
    dataIndex: 'last_audit_date',
    key: 'last_audit_date',
  },
  {
    title: 'Notice period',
    width: 150,
    dataIndex: 'notice_period',
    key: 'notice_period',
  },
  {
    title: 'Rank',
    width: 150,
    dataIndex: 'rank',
    key: 'rank',
  },
  {
    title: 'Recipient identification code',
    width: 150,
    dataIndex: 'recipient_identification_code',
    key: 'recipient_identification_code',
  },
  {
    title: 'Recipient identification type',
    width: 150,
    dataIndex: 'recipient_identification_type',
    key: 'recipient_identification_type',
  },
  {
    title: 'Substitutability',
    width: 150,
    dataIndex: 'substitutability',
    key: 'substitutability',
    render: (value: boolean) => (value ? 'True' : 'False'),
  },
  {
    title: 'Third party service provider legal name',
    width: 150,
    dataIndex: 'third_party_service_provider_legal_name',
    key: 'third_party_service_provider_legal_name',
  },
  {
    title: 'Third party service provider name',
    width: 150,
    dataIndex: 'third_party_service_provider_name',
    key: 'third_party_service_provider_name',
  },
  {
    title: 'Criticality assessment',
    width: 150,
    dataIndex: 'criticality_assessment',
    key: 'criticality_assessment',
  },
  {
    title: 'Dora regulator criticality',
    width: 150,
    dataIndex: 'dora_regulator_criticality',
    key: 'dora_regulator_criticality',
  },
  {
    title: 'Dora regulator criticality label',
    width: 150,
    dataIndex: 'dora_regulator_criticality_label',
    key: 'dora_regulator_criticality_label',
  },
  {
    title: 'Exit plan exists',
    width: 150,
    dataIndex: 'exit_plan_exists',
    key: 'exit_plan_exists',
  },
  {
    title: 'Non substitutability reason',
    width: 200,
    dataIndex: 'non_subst_reason',
    key: 'non_subst_reason',
  },
  {
    title: 'possibility of reintegration',
    width: 150,
    dataIndex: 'possibility_of_reintegration',
    key: 'possibility_of_reintegration',
  },
  {
    title: 'Substitutability of ICT provider',
    width: 150,
    dataIndex: 'substitutability_of_ict_provider',
    key: 'substitutability_of_ict_provider',
  },
];

export const columnsTPPSecond: TableColumnsType<DataTypeReportTPP> = [
  {
    title: 'Name of the financial entity',
    width: 150,
    dataIndex: 'entity_name',
    key: 'entity_name',
    fixed: 'left',
  },
  {
    title: 'Alternative providers identified',
    width: 150,
    dataIndex: 'alternative_providers_identified',
    key: 'alternative_providers_identified',
  },
  {
    title: 'Additional ICT service provider identification code',
    width: 150,
    dataIndex: 'add_ict_service_provider_identification_code',
    key: 'add_ict_service_provider_identification_code',
  },
  {
    title: 'Additional identification code type',
    width: 150,
    dataIndex: 'add_identification_code_type',
    key: 'add_identification_code_type',
  },
  {
    title: 'ICT service provider identification code',
    width: 150,
    dataIndex: 'ict_service_provider_identification_code',
    key: 'ict_service_provider_identification_code',
  },
  {
    title: 'ICT service provider lei',
    width: 150,
    dataIndex: 'ict_service_provider_lei',
    key: 'ict_service_provider_lei',
  },
  {
    title: 'Identification code type',
    width: 200,
    dataIndex: 'identification_code_type',
    key: 'identification_code_type',
  },
  {
    title: 'Ultimate parent identification code',
    width: 150,
    dataIndex: 'ultimate_parent_identification_code',
    key: 'ultimate_parent_identification_code',
  },
  {
    title: 'Ultimate parent identification code type',
    width: 150,
    dataIndex: 'ultimate_parent_identification_code_type',
    key: 'ultimate_parent_identification_code_type',
  },
  {
    title: 'TPP code type',
    width: 200,
    dataIndex: 'tpp_code_type',
    key: 'tpp_code_type',
  },
];
